function getElementFromRef(ref) {
  if (ref && 'current' in ref) {
    return ref.current;
  }
  return ref;
}

export { getElementFromRef as g };
//# sourceMappingURL=getElementFromRef-DUWqD2Fg.js.map
